import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import 'react';

const MediumPersonAdd = ({ testId, className, solid })=>{
    return /*#__PURE__*/ jsx("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        "data-testid": testId,
        className: className,
        children: solid ? /*#__PURE__*/ jsxs(Fragment, {
            children: [
                /*#__PURE__*/ jsx("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M11.6998 13.6C11.6598 12.99 11.4798 11.68 10.6798 10.51C9.8498 9.28999 8.39981 8.29999 6.0098 8.29999L5.9598 8.31999L5.9998 8.29999C3.5998 8.29999 2.1498 9.29999 1.3198 10.51C0.519805 11.68 0.339805 12.99 0.299805 13.6C0.299805 13.6 0.299805 13.63 0.299805 13.65V14C0.299805 14.39 0.609805 14.7 0.999805 14.7H10.9998C11.3898 14.7 11.6998 14.39 11.6998 14V13.65C11.6998 13.65 11.6998 13.62 11.6998 13.6Z",
                    fill: "currentColor"
                }),
                /*#__PURE__*/ jsx("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M2.7998 4.49999C2.7998 2.73268 4.23249 1.29999 5.9998 1.29999C7.76712 1.29999 9.1998 2.73268 9.1998 4.49999C9.1998 6.2673 7.76712 7.69999 5.9998 7.69999C4.23249 7.69999 2.7998 6.2673 2.7998 4.49999Z",
                    fill: "currentColor"
                }),
                /*#__PURE__*/ jsx("path", {
                    d: "M11 7H15",
                    stroke: "currentColor",
                    strokeWidth: "1.4",
                    strokeLinecap: "round"
                }),
                /*#__PURE__*/ jsx("path", {
                    d: "M13 5L13 9",
                    stroke: "currentColor",
                    strokeWidth: "1.4",
                    strokeLinecap: "round"
                })
            ]
        }) : /*#__PURE__*/ jsxs(Fragment, {
            children: [
                /*#__PURE__*/ jsx("path", {
                    d: "M1 14V13.6465C1.07817 12.5347 1.66146 9 6.00301 9H5.99699C10.3385 9 10.9218 12.5283 11 13.6465V14",
                    stroke: "currentColor",
                    strokeWidth: "1.4",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                }),
                /*#__PURE__*/ jsx("path", {
                    d: "M6 7C7.38071 7 8.5 5.88071 8.5 4.5C8.5 3.11929 7.38071 2 6 2C4.61929 2 3.5 3.11929 3.5 4.5C3.5 5.88071 4.61929 7 6 7Z",
                    stroke: "currentColor",
                    strokeWidth: "1.4",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                }),
                /*#__PURE__*/ jsx("path", {
                    d: "M11 7H15",
                    stroke: "currentColor",
                    strokeWidth: "1.4",
                    strokeLinecap: "round"
                }),
                /*#__PURE__*/ jsx("path", {
                    d: "M13 5L13 9",
                    stroke: "currentColor",
                    strokeWidth: "1.4",
                    strokeLinecap: "round"
                })
            ]
        })
    });
};

export { MediumPersonAdd as default };
